const trimTrailingSlash = value => value.replace(/\/+$/, "");
const trimLeadingSlash = value => value.replace(/^\/+/, "");

const DEFAULT_BACKEND_BASE_URL = process.env.NODE_ENV === "production"
    ? "https://g.lycoding.cn"
    : "http://localhost:3000";

const DEFAULT_MATCHING_BASE_URL = process.env.NODE_ENV === "production"
    ? "https://g.lycoding.cn"
    : "http://localhost:3001";

const DEFAULT_BOT_RUNNING_BASE_URL = process.env.NODE_ENV === "production"
    ? "https://g.lycoding.cn"
    : "http://localhost:3002";

export const BACKEND_BASE_URL = trimTrailingSlash(
    process.env.VUE_APP_BACKEND_BASE_URL || DEFAULT_BACKEND_BASE_URL
);

export const MATCHING_BASE_URL = trimTrailingSlash(
    process.env.VUE_APP_MATCHING_BASE_URL || DEFAULT_MATCHING_BASE_URL
);

export const BOT_RUNNING_BASE_URL = trimTrailingSlash(
    process.env.VUE_APP_BOT_RUNNING_BASE_URL || DEFAULT_BOT_RUNNING_BASE_URL
);

export const WS_BASE_URL = trimTrailingSlash(
    process.env.VUE_APP_WS_BASE_URL || BACKEND_BASE_URL.replace(/^http/, "ws")
);

export const MATCHING_WS_BASE_URL = trimTrailingSlash(
    process.env.VUE_APP_MATCHING_WS_BASE_URL || MATCHING_BASE_URL.replace(/^http/, "ws")
);

export const BOT_RUNNING_WS_BASE_URL = trimTrailingSlash(
    process.env.VUE_APP_BOT_RUNNING_WS_BASE_URL || BOT_RUNNING_BASE_URL.replace(/^http/, "ws")
);

export const TRAINING_URL = process.env.VUE_APP_TRAINING_URL || "/training/";

const joinUrl = (baseUrl, path) => `${baseUrl}/${trimLeadingSlash(path)}`;

export const apiUrl = path => joinUrl(BACKEND_BASE_URL, path);
export const wsUrl = path => joinUrl(WS_BASE_URL, path);
export const matchingApiUrl = path => joinUrl(MATCHING_BASE_URL, path);
export const matchingWsUrl = path => joinUrl(MATCHING_WS_BASE_URL, path);
export const botRunningApiUrl = path => joinUrl(BOT_RUNNING_BASE_URL, path);
export const botRunningWsUrl = path => joinUrl(BOT_RUNNING_WS_BASE_URL, path);
